export const webTemplate = {
    slug: 'web-template',
    no: '08',
    type: 'note',
    title: 'Individual Development Plan',
    category: 'UX Design',
    sourceUrl: 'https://himanshutanty.com/portfolio/web-template/',
    // Real text from source
    note: 'This is a web design about Social Media Dashboard.',
    greeting: 'Hello Friends 👋',
    closing: [
        'Don\u2019t forget to like ❤️',
        'Say what you think in the comments 💬',
    ],
    // Real images from source
    gallery: [
        'https://himanshutanty.com/wp-content/uploads/2024/07/post3-1.jpg',
        'https://himanshutanty.com/wp-content/uploads/2024/07/post2.jpg',
        'https://himanshutanty.com/wp-content/uploads/2024/07/post1-1.jpg',
    ],
    next: { slug: 'beyond-the-dashboard', title: 'The Future of Intelligent Trucks' },
};
